import { NgClass } from '@angular/common';
import { Component, input } from '@angular/core';

@Component({
  selector: 'lib-section',
  imports: [NgClass],
  templateUrl: './section.html',
  styleUrl: './section.scss',
})
export class Section {
  public readonly icon = input<string>();
  public readonly iconColor = input<'teal' | 'slate'>('slate');
  public readonly title = input.required<string>();
  public readonly hasBorder = input<boolean>(true);
}
